import lessRequire from '../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Link } from 'react-router';
import SelectField from '../shared/form-elements/select';
import Avatar from '../shared/avatar';
import { baseUrl } from '../../config/route-entry-point';
import qs from 'qs';
import pubDefaultAva from '../../apps/everad/assets/img/global/default-avatars/web_40x40.png';

lessRequire('modules/affiliates/entity.less');

const offerRowHeight = 50;
const firstOfferRowHeight = 60;

const Affiliate = ({
	className,
	type,
	parentName,
	index,
	intl,
	fields,
	placeholder,
	entityOptions,
	onToggleOffersPan,
	onFetchOffers,
	offersAmount,
	shouldShowOffers,
	shownTargetPixelHeightsMap,
	copyTerms
}) => (
	<tr className={`entity-affiliate ${className}`} onClick={e => onToggleOffersPan(index)}>
		<td className="entity-type">
			{shouldShowOffers && offersAmount ? (
				<div
					className="vertical-line"
					style={{
						height: offersAmount
							? firstOfferRowHeight + (offersAmount - 1) * offerRowHeight + (shownTargetPixelHeightsMap[index] || 0)
							: firstOfferRowHeight
					}}
				/>
			) : null}
			<Field
				name={`${parentName}.${type}`}
				placeholder={placeholder}
				component={SelectFieldWithImage}
				image={getAffiliateAvatar(fields.get(index)['affiliate'])}
				multi={false}
				shouldDisable={!!fields.get(index)}
				options={entityOptions}
			/>
		</td>
		<td className="entity-offers">
			<span>{fields.get(index)['offer_ids'].length}</span>
		</td>
		<td className="entity-affiliate-revenue">
			<span>{fields.get(index)['affiliate']['usdRevenue'] || 0}</span>
		</td>
		{
			process.env.CPA_ENV === 'everad' &&
			<td className="entity-affiliate-revenue">
				<span>{fields.get(index)['affiliate']['eurRevenue'] || 0}</span>
			</td>
		}
		<td className="entity-actions">
			<div className="actions__wrap">
				{/* <a //commented, according cpa-1305
					className="copy-terms-link"
					href="#"
					onClick={e => {
						e.preventDefault();
						e.stopPropagation();
						confirm(
							intl(
								'Вы уверены, что хотите скопировать свои ставки этому вебмастеру по всем офферам?' +
								' Его текущие ставки сбросятся.'
							)
						) && copyTerms(fields.get(index)['affiliate']);
					}}>
					{intl('Копировать')}
				</a> */}
				<Link
					to={baseUrl(`statistics/general?${statisticQuery(fields.get(index)['affiliate'])}`)}
					target="_blank"
					className="statistics"
					title={intl('Статистика')}
					onClick={e => e.stopPropagation()}
				/>
				<span className="toggle" />
			</div>
		</td>
	</tr>
);

const SelectFieldWithImage = props => {
	return (
		<div>
			<SelectField {...props}>
				<Avatar src={props.image} className="select-image" />
			</SelectField>
		</div>
	);
};

const getAffiliateAvatar = affiliate => {
	return affiliate.image || pubDefaultAva;
};

const statisticQuery = affiliate => {
	return qs.stringify({
		groups: ['date'],
		filters: {
			affiliates: [
				{
					id: affiliate.value,
					text: affiliate.label
				}
			]
		}
	});
};

SelectFieldWithImage.propTypes = {
	image: PropTypes.string
};

Affiliate.propTypes = {
	className: PropTypes.string,
	type: PropTypes.string,
	parentName: PropTypes.string,
	index: PropTypes.any,
	intl: PropTypes.func,
	fields: PropTypes.object,
	placeholder: PropTypes.string,
	entityOptions: PropTypes.array,
	onToggleOffersPan: PropTypes.func,
	onFetchOffers: PropTypes.func,
	offersAmount: PropTypes.number,
	shouldShowOffers: PropTypes.bool,
	shownTargetPixelHeightsMap: PropTypes.object,
	copyTerms: PropTypes.func
};

export default Affiliate;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/affiliates/affiliate.js